//
// StyleTarget.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "./AttributeMapping";

var StyleTarget = createModule("BIRD::StyleTarget", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        attributeMapping: [1],
        targetClass: 7,
        indexedTargetClassPrefix: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default StyleTarget;
